<template>
  <v-row>
    <v-dialog v-model="dialog" persistent max-width="350">
      <template v-slot:activator="{ on }">
        <v-btn block :loading="dialog" color="success" v-on="on"
          >Exchange</v-btn
        >
      </template>
      <v-card>
        <v-toolbar flat color="lime">
          <v-toolbar-title
            >Account {{ AccountNumber.toLocaleString() }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon :loading="Loading" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <Exchange
          :showBalance="showBalance"
          :AccountNumber="AccountNumber"
          :closed="dialog"
          :isLoading="isLoading"
        ></Exchange>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import ExchangeBank from "@/components/ExchangeBank";
export default {
  props: { AccountNumber: [Number], Finished: [Function] },
  components: { Exchange: ExchangeBank },
  data() {
    return {
      Loading: false,
      dialog: false,
    };
  },
  methods: {
    showBalance(data) {
      this.Finished(data);
    },
    isLoading(val = false, isFinish = "No") {
      this.Loading = val;
      if (isFinish == "Finished") this.dialog = false;
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>
